import type { ReactNode } from "react";

import { IgDialog } from "@intelligems/ig-theme/IgDialog";
import { Box } from "@mui/material";

import { ModuleDemoVideo } from "@src/components/ModuleDemoVideo/ModuleDemoVideo";
import { GateChip } from "@src/components/PricingGatedModal/GateChip";

interface ModuleTrialWelcomeDialogViewProps {
  isOpen: boolean;
  title: string;
  chipLabel: string;
  moduleDisplayName: string;
  description: string;
  videoPlaybackId?: string;
  graphic: ReactNode;
  onClose: () => void;
  onViewTemplates: () => void;
}

export function ModuleTrialWelcomeDialogView({
  isOpen,
  title,
  chipLabel,
  moduleDisplayName,
  description,
  videoPlaybackId,
  graphic,
  onClose,
  onViewTemplates,
}: ModuleTrialWelcomeDialogViewProps) {
  return (
    <IgDialog
      showDialog={isOpen}
      handleClose={onClose}
      handleNoClick={onClose}
      handleYesClick={onViewTemplates}
      showCloseIcon={true}
      fullWidth={true}
      maxWidth="sm"
      minWidth="min(680px, calc(100vw - 32px))"
      dialogHeight={null}
      dialogContentWidth="100%"
      dialogImage={<GateChip label={chipLabel} sx={{ mb: 2 }} />}
      title={title}
      subtitle={description}
      content={
        videoPlaybackId ? (
          <Box
            sx={{
              aspectRatio: "16 / 9",
              borderRadius: 2,
              overflow: "hidden",
              position: "relative",
              width: "100%",
            }}
          >
            <ModuleDemoVideo
              playbackId={videoPlaybackId}
              title={moduleDisplayName}
            />
          </Box>
        ) : (
          <Box sx={{ borderRadius: 2, overflow: "hidden" }}>{graphic}</Box>
        )
      }
      noButtonText="Do this later"
      yesButtonText="View templates"
    />
  );
}
